import { Reveal } from "./Reveal";
import { WORKS } from "../data";

const WorkCard = ({ work, index }) => {
  const images = work.images || [];
  return (
    <Reveal delay={0.05}>
      <figure
        data-testid={`work-${index}`}
        id={work.title === "Headshots" ? "headshots" : undefined}
        className="group scroll-mt-24"
      >
        <figcaption className="mb-6 border-b border-border pb-4">
          <h3 className="font-serif text-3xl lg:text-4xl font-light text-foreground">
            {work.title}
          </h3>
          {work.client && (
            <p className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
              {work.client}
            </p>
          )}
        </figcaption>
        {/* Photos stacked vertically, natural aspect (space reserved via width/height to avoid layout shift) */}
        <div className="space-y-6 lg:space-y-8">
          {images.map((img, i) => (
            <div key={i} className="border border-border p-3 lg:p-4 bg-card">
              <img
                src={img.src}
                width={img.w}
                height={img.h}
                alt={work.title}
                loading="lazy"
                className="w-full h-auto block"
              />
            </div>
          ))}
        </div>
      </figure>
    </Reveal>
  );
};

export const Work = () => {
  return (
    <section id="work" data-testid="work-section" className="px-6 lg:px-12 py-24 lg:py-40">
      <div className="mx-auto max-w-3xl space-y-24 lg:space-y-32">
        {WORKS.map((w, i) => (
          <WorkCard key={i} work={w} index={i} />
        ))}
      </div>
    </section>
  );
};
